import { useGetMilkingProcessDeviationList } from 'hook/query/useGetMilkingProcessDeviationList'
import moment from 'moment'
import { useWidgetPreview } from '../context/WidgetPreviewContext'
import { MILKING_PROCESS_DEVIATION_MOCK } from '../mocks/milkingProcessDeviationMock'

const startDate = moment().startOf('day').valueOf()
const endDate = moment().endOf('day').valueOf()

export const useWidgetMilkingDeviationList = () => {
	const { isPreview } = useWidgetPreview()
	const real = useGetMilkingProcessDeviationList(
		startDate,
		endDate,
		'all',
		1,
		36,
		'all',
		undefined,
		undefined,
		undefined,
		{ enabled: !isPreview },
	)

	if (isPreview) {
		return {
			data: MILKING_PROCESS_DEVIATION_MOCK,
			isLoading: false,
			isError: false,
			error: undefined,
			refetch: () => {},
		}
	}

	return real
}
